module.exports = __webpack_public_path__ + "static/media/chalk1080.00d9574f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/background/chalk1080.jpg
// module id = 1305
// module chunks = 0